angular.module('gym.components').directive('reportSequenceConditions', function() {
  return {
    restrict: 'EA',
    template: require('templates/components/sequences/reportSequenceConditions.html.slim'),
    scope: {
      sequence: '=',
      step: '=',
      skip: '='
    },
    controller: ["$scope", "SequenceService", function($scope, SequenceService) {
      var conditions, getCondition, getScopedCondition, presentFiltersCount;
      conditions = $scope.step.sequence_conditions_attributes;
      $scope.reportConditionType = $scope.skip ? 'ReportSkipSequenceCondition' : 'ReportSequenceCondition';
      $scope.scopedReportConditionType = $scope.skip ? 'ScopedReportSkipSequenceCondition' : 'ScopedReportSequenceCondition';
      getCondition = function() {
        var conditionIndex;
        conditionIndex = _.findIndex(conditions, function(condition) {
          return condition.type === $scope.reportConditionType;
        });
        return $scope.condition = $scope.step.sequence_conditions_attributes[conditionIndex];
      };
      getScopedCondition = function() {
        var scopedConditionIndex;
        scopedConditionIndex = _.findIndex(conditions, function(condition) {
          return condition.type === $scope.scopedReportConditionType;
        });
        return $scope.scopedCondition = $scope.step.sequence_conditions_attributes[scopedConditionIndex];
      };
      $scope.$watch('step', function() {
        getCondition();
        return getScopedCondition();
      }, true);
      $scope.$watch('sequence.trigger', function(trigger, oldTrigger) {
        var availableColumnOptions, filters;
        if (trigger !== oldTrigger && $scope.scopedCondition) {
          availableColumnOptions = [];
          filters = $scope.scopedCondition.report_attributes.report_filters_attributes;
          $scope.sequence.sequence_object_map[trigger].forEach(function(item) {
            return _.each($scope.sequence.sequence_object_report_options[item], function(val) {
              return availableColumnOptions = availableColumnOptions.concat(val);
            });
          });
          return filters.forEach(function(filter, index) {
            var foundColumn;
            foundColumn = _.find(availableColumnOptions, function(option) {
              return option.unique_id === filter.database_value;
            });
            if (!foundColumn) {
              return $scope.remove($scope.scopedCondition, index, $scope.scopedReportConditionType);
            }
          });
        }
      });
      presentFiltersCount = function(filters) {
        return _.filter(filters, function(filter) {
          return !filter._destroy;
        }).length;
      };
      return $scope.remove = function(condition, index, type) {
        var filters;
        filters = condition.report_attributes.report_filters_attributes;
        if (filters[index].id) {
          filters[index]._destroy = 1;
          if (presentFiltersCount(filters) === 0) {
            return condition._destroy = 1;
          }
        } else {
          if (filters.length > 1) {
            return filters.splice(index, 1);
          } else {
            return SequenceService.removeReportCondition($scope.step, type);
          }
        }
      };
    }]
  };
});
